<template>
    <li @click.stop="selectPattern" class="pattern"
        :class="[pattern == activePattern ? 'is-active' : '', pattern.isBW ? 'is-bw' : '']">
        <div class="pattern__image"
             :class="'pattern__image--' + pattern.name"
             :style="{'background-image': 'url(' + imageSrcBW + ')'}"
        >
            <div class="pattern__image-color"
                 :class="'pattern__image--' + pattern.name"
                 :style="{'background-image': 'url(' + imageSrc + ')'}"
            ></div>
            <template v-if="pattern.colorToggle">
                <div class="pattern__bw-switch" :class="pattern.isBW ? 'is-active' : ''"
                     @click.stop="selectBW">
                    <div class="indicator"></div>
                </div>
                <div class="pattern__bw-switch-label">
                    Black & White
                </div>
            </template>
        </div>
    </li>
</template>

<script>
    export default {
        props: ['activePattern', 'pattern'],
        computed: {
            imageSrc() {
                return require('../../assets/patterns/' + this.pattern.name + '.svg');
            },
            imageSrcBW() {
                return require('../../assets/patterns/' + this.pattern.name + '_bw.svg');
            },
            imageSrcName() {
                return require('../../assets/patterns/' + this.pattern.name + '_name.svg');
            },
        },
        methods: {
            selectBW() {
                this.pattern.isBW = !this.pattern.isBW;
                this.$emit('colorChanged', this.pattern);
            },
            selectPattern() {
                if (this.pattern != this.activePattern) {
                    this.$emit('patternSelected', this.pattern);
                }
            }
        }

    }
</script>

<style lang="scss" scoped>
    @import '../../assets/scss/animations/fade';

    .pattern {
        border: 1px solid rgba(255, 255, 255, 0.3);
        cursor: pointer;
        display: inline-block;
        margin-bottom: 9px;
        position: relative;
        text-align: center;
        transition: border .2s linear;
        vertical-align: top;
        width: 100%;

        @media (min-width: 768px) {
            width: calc(50% - 16px);
            margin: 0 16px 16px 0;
        }

        &__image {
            background-color: #000;
            background-position: center;
            background-repeat: no-repeat;
            background-size: 200%;
            border: 3px solid #000;
            position: relative;
            transition: border .2s linear;
        }

        &__image-color {
            background-color: #000;
            background-position: center;
            background-repeat: no-repeat;
            background-size: 200%;
            height: 118px;
            transition: opacity .2s linear;
            width: 100%;
        }

        &__name {
            left: 10px;
            position: absolute;
            top: 10px;

            img {
                height: 17px;
                width: auto;
            }
        }

        &__bw-switch {
            border: 2px solid rgba(255, 255, 255, 0.5);
            border-radius: 100px;
            bottom: 17px;
            height: 26px;
            left: 16px;
            position: absolute;
            width: 43px;
            transition: border .2s linear;

            .indicator {
                border: 2px solid #FFFFFF;
                border-radius: 50%;
                height: 16px;
                margin: 3px;
                transition: all .2s ease-in-out;
                width: 16px;
            }

            &.is-active {
                border: 2px solid rgba(255, 255, 255, 0.8);

                .indicator {
                    background: #FFF;
                    margin-left: 18px;
                }
            }
        }

        &__bw-switch-label {
            bottom: 20px;
            font-family: PxGroteskRegular;
            font-size: 13px;
            left: 74px;
            position: absolute;
        }

        &.is-active {
            .pattern__image {
                border: 3px solid #FFFFFF;
                cursor: default;

                &::before {
                    animation: fadeIn .25s linear;
                    background: transparent url('../../assets/checked.svg');
                    content: '';
                    height: 7px;
                    position: absolute;
                    top: 14px;
                    right: 14px;
                    width: 9px;
                    z-index: 10;
                }
            }
        }

        &.is-bw {
            .pattern__image-color {
                opacity: 0;
            }
        }
    }

    .pattern__image--sipgate {
        background-size: 300%;
        background-position: center center;
    }

</style>


// WEBPACK FOOTER //
// src/components/panels/Pattern.vue